/**
 * The flat set of back-office abilities. Each gated route belongs to exactly
 * one ability, and an account's abilities follow from its role
 * (`ability.service.ts`). Shared vocabulary between backend gating and
 * frontend UI gating.
 */
export enum AdminAbility {
	UsersManage = 'users.manage',
	AdminsManage = 'admins.manage',
	ResidencesManage = 'residences.manage',
	CallManage = 'call.manage',
	EventLogRead = 'event_log.read',
	EmailTextsManage = 'email_texts.manage',
	SendingMonitor = 'sending.monitor',
	/** The general admin follows the calls of every residence and reminds the managers (FFD 3.6). */
	CallMonitor = 'call.monitor',
	SupportManage = 'support.manage'
}

/** The two back-office roles (decision D13). */
export enum BackofficeRole {
	GeneralAdmin = 'general_admin',
	FacilityManager = 'facility_manager'
}
